module.exports = __webpack_public_path__ + "img/content1.005b2b7d.png";